import { Link } from "react-router-dom";

// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import AsyncSelect from "react-select/async";

import { useState } from "react";
import TypesApi from "../../../../../Classes/API/UsersApi";

import SearchEmployeeTypes from "../../../../../Classes/Models/Requests/Administration/Employees/SearchEmployeeTypes";
import AddEmployeeToTypeReq from "../../../../../Classes/Models/Requests/AddManyToManyReq";

const EmployeeInfoCard = ({ User, GetUserData, shadow }) => {
  const Employee = User.getEmployee;

  const [SelectedTypeId, setTypeId] = useState(
    Employee.getEmployeeType && Employee.getEmployeeType.id
  );

  const [TypesSearch, setTypesSearch] = useState("");

  const NoTypeOption = { value: "", label: "*Not Assigned!!!" };

  const getTypeDefaultOption = () => {
    if (Employee.getEmployeeType) {
      return { value: Employee.getEmployeeType.id, label: Employee.getEmployeeType.typeName };
    } else {
      return NoTypeOption;
    }
  };
  const GetTypes = async () => {
    let req = new SearchEmployeeTypes();
    req.typeName = TypesSearch;
    var res = await TypesApi.SearchEmployeeTypes(req);
    console.log(res);
    // setEmployeeTypes(res.data.list)
    let optionsArr = [];
    res.data.list.forEach((item) => {
      optionsArr.push({ value: item.id, label: item.typeName });
    });

    return optionsArr;
  };

  const SaveType = async () => {
    let req = new AddEmployeeToTypeReq();
    req.Id1 = Employee.id;
    req.Id2 = SelectedTypeId;
    var res = await TypesApi.AssignEmployeeToType(req);

    if (res.status == "Success") {
      GetUserData(User.id);
    }
  };

  return (
    <Card sx={{ height: "100%", boxShadow: !shadow && "none" }}>
      <MDBox display="flex" justifyContent="space-between" alignItems="left" pt={2} px={2}>
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          Employee Info
        </MDTypography>
        {/* <MDTypography   variant="body2" color="secondary">
          <Tooltip   placement="top">
            <Icon>edit</Icon>
          </Tooltip>
        </MDTypography> */}
      </MDBox>
      <MDBox p={2}>
        <MDBox>
          <MDBox display="flex" py={1} pr={2}>
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              Employee Id: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{Employee.id}
            </MDTypography>
          </MDBox>

          {/* <MDBox display="flex" py={1} pr={2}>
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              Employee Type: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              <AsyncSelect
                isClearable={true}
                defaultValue={getTypeDefaultOption}
                loadOptions={GetTypes}
                onInputChange={setTypesSearch}
                onChange={(e) => setTypeId(e ? e.value : "")}
                // value={TypeId}
              />
            </MDTypography>
            <button onClick={() => SaveType()} className="btn btn-outline-dark ml-3">
              Save
            </button>
          </MDBox> */}

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              HourlyRate: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{Employee.getEmployeeType ? Employee.getEmployeeType.standardHourlyRate : "NA"}
            </MDTypography>
          </MDBox>

          <MDBox display="flex" py={1} pr={2}>
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              Hours Worked: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{Employee.hoursWorked}
            </MDTypography>
          </MDBox>
          <MDBox display="flex" py={1} pr={2}>
            <MDTypography variant="button" fontWeight="bold" textTransform="capitalize">
              Hours Paid: &nbsp;
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{Employee.hoursPaid}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
};

// Setting default props for the ProfileInfoCard
EmployeeInfoCard.defaultProps = {
  shadow: true,
};

// Typechecking props for the ProfileInfoCard
EmployeeInfoCard.propTypes = {
  shadow: PropTypes.bool,
};

export default EmployeeInfoCard;
